// Keyboard parity for non-button elements that carry an onClick
// (WCAG 2.2 SC 2.1.1 Keyboard, 4.1.2 Name/Role/Value).
//
// Enter and Space re-dispatch a real click on the element, so the element's
// existing onClick runs unchanged — one handler, no duplicated logic. Paired
// with role="button" and tabIndex={0} at each call site.
const activateOnKey = (e) => {
  if (e.target !== e.currentTarget) return; // a nested field owns its own keys
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    e.currentTarget.click();
  }
};

export default activateOnKey;
